import Model from '@/models/Model.js';

export default class TimePeriodTemplateLocation extends Model {
    static entity = 'time_period_template_location';

    static modelName = 'TimePeriodTemplateLocation';

    static primaryKey = ['time_period_template_id', 'location_id'];

    static fields() {
        return {
            location_id: this.attr(null),
            time_period_template_id: this.attr(null),

            ...super.fields(),

            location: this.belongsTo('locations', 'location_id'),
            time_period_template: this.belongsTo('time_period_templates', 'time_period_template_id'),
        };
    }
}
